import { AppRoutes } from './types'

export const ENV = process.env.NODE_ENV
export const PUBLIC_URL = process.env.REACT_APP_PUBLIC_URL

export const DATE_NOW = Date.now().toString()

export const VETRO_API_DOMAIN = process.env.REACT_APP_VETRO_API_DOMAIN;
export const VETRO_API_TOKEN = process.env.REACT_APP_VETRO_API_TOKEN;
export const CLEARCO_WIDGET_CODE = process.env.REACT_APP_CLEARCO_WIDGET_CODE;
export const API_DOMAIN = process.env.REACT_APP_API_DOMAIN;

export const BASE_PAGE_TILE = 'Cityside Fiber | Built for SoCal'

export const ROUTES: AppRoutes = {
  landing: {
    path: '/',
    title: BASE_PAGE_TILE,
  },
  login: {
    path: 'https://citysidefiber.broadbandportal.net/?showLogin=true',
    title: 'Login',
  },
  checkAvailability: {
    path: '/check-availability',
    title: `${BASE_PAGE_TILE}: Check Availability`,
  },
  gigInternet: {
    path: '/home-internet',
    title: `${BASE_PAGE_TILE}: Gig Internet - View All Packages`,
  },
  connectAndControl: {
    path: '/connect-and-control',
    title: `${BASE_PAGE_TILE}: Connect & Control - 1Gig`,
  },
  workHardPlayHard: {
    path: '/work-hard-play-hard',
    title: `${BASE_PAGE_TILE}: Work Hard, Play Hard - 2Gigs`,
  },
  everythingAndEverywhere: {
    path: '/everything-and-everywhere',
    title: `${BASE_PAGE_TILE}: Everything & Everywhere - 5 Gigs`,
  },
  businessSolutions: {
    path: '/smartbiz',
    title: `${BASE_PAGE_TILE}: SmartBiz`,
  },
  apartmentProjects: {
    path: '/apartment-projects',
    title: `${BASE_PAGE_TILE}: Apartment Projects`,
  },
  hoaProjects: {
    path: '/hoa-projects',
    title: `${BASE_PAGE_TILE}: HOA Projects`,
  },
  aboutUs: {
    path: '/about-us',
    title: `${BASE_PAGE_TILE}: About Us`,
  },
  referralProgram: {
    path: '/referral-program',
    title: `${BASE_PAGE_TILE}: Referral Program`,
  },
  joinOurTeam: {
    path: '/join-our-team',
    title: `${BASE_PAGE_TILE}: Join Our Team`,
  },
  construction: {
    path: '/construction',
    title: `${BASE_PAGE_TILE}: Construction`,
  },
  currentServiceAreas: {
    path: '/current-service-areas',
    title: `${BASE_PAGE_TILE}: Current Service Areas`,
  },
  streaming: {
    path: '/streaming',
    title: `${BASE_PAGE_TILE}: Streaming`,
  },
  aboutFiber: {
    path: '/about-fiber',
    title: `${BASE_PAGE_TILE}: About Fiber`,
  },
  blog: {
    path: '/blog/:page',
    altPath: '/blog',
    title: `${BASE_PAGE_TILE}: Blog & News`,
  },
  blogArticle: {
    path: '/blog/article/:id',
    title: `${BASE_PAGE_TILE}: Blog & News`,
  },
  websiteTerms: {
    path: '/website-terms',
    title: `${BASE_PAGE_TILE}: Website Terms of Service`,
  },
  residentialTerms: {
    path: '/residential-terms',
    title: `${BASE_PAGE_TILE}: Residential Service Terms and Conditions`,
  },
  commercialTerms: {
    path: '/commercial-terms',
    title: `${BASE_PAGE_TILE}: SMB Services Agreement`,
  },
  privacy: {
    path: '/privacy-policy',
    title: `${BASE_PAGE_TILE}: Privacy Policy`,
  },
  aup: {
    path: '/aup',
    title: `${BASE_PAGE_TILE}: Acceptable Use Policy`,
  },
  dmcaPolicy: {
    path: '/dmca-policy',
    title: `${BASE_PAGE_TILE}: DMCA Policy`,
  },
  betaAgreement: {
    path: '/beta-agreement',
    title: `${BASE_PAGE_TILE}: Beta Agreement`,
  },
  policies: {
    path: '/policies',
    title: `${BASE_PAGE_TILE}: Our Policies`,
  },
}
